import React, { useEffect, useState } from 'react'
import styles from './wizardUpload.module.css'
import { Upload } from '../../../Svg'
import { useDispatch, useSelector } from 'react-redux'
import { getMatchedProductsThunk, setSelectedProducts } from '../../redux/bomSlice'
import WizardTable from '../../components/OtherComps/wizard/WizardTable'
import * as XLSX from "xlsx";

const WizardUpload = () => {
    // eslint-disable-next-line no-unused-vars
    const [showLogin, setShowLogin] = useState(false)
    const { isLoggedin } = useSelector((state) => state.customer)
    const dispatch = useDispatch()
    const [productsearch, setProductsearch] = useState('')
    const [wizardProducts, setWizardProducts] = useState([])
    const [filename, setFileName] = useState(null)
   
    // eslint-disable-next-line no-unused-vars
    const [submitLoading, setSubmitLoading] = useState(false)

    const handlesearch = async (products) => {
        const prod = products?.map(i => ({
            productNumber: i
        }))
        const response = await dispatch(getMatchedProductsThunk(prod))
        setWizardProducts(response.payload || [])
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        setFileName(file.name)
        if (file) {
            const reader = new FileReader();
            reader.onload = async (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                const response = await dispatch(getMatchedProductsThunk(jsonData))
                setWizardProducts(response.payload || [])
            };
            reader.readAsBinaryString(file);
        }
    };

    return (
        <>
            <div className={styles.imgBread}>
                <span>Wizard Tool</span>
            </div>

            <div className={styles.wizardFlexContainer}>
                <div className={styles.leftColumn}>
                    <div className={styles.crossSearchCard}>
                        <p>Search for excess inventory products</p><br />
                        <h3> Items search</h3>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '30px', width: '100%' }}>
                            <form className={styles.searchContainer} onSubmit={(e) => e.preventDefault()}>
                                <input
                                    type="text"
                                    placeholder="Enter part #"
                                    className={styles.searchInput}
                                    onChange={(e) => setProductsearch(e.target.value)}
                                />
                                <button className={styles.searchBtn} onClick={() => handlesearch([productsearch])}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.33488 11.0342C4.23694 11.68 5.29827 12.0252 6.38462 12.0252C7.10587 12.0252 7.81987 11.873 8.48579 11.5774C9.15169 11.2819 9.75628 10.849 10.2652 10.3037C10.7742 9.75837 11.1775 9.11138 11.4526 8.39981C11.7277 7.68824 11.8692 6.92579 11.8692 6.15596C11.8692 4.99661 11.5484 3.86278 10.9466 2.89782C10.3448 1.93281 9.48872 1.17957 8.48579 0.734475C7.48276 0.289331 6.37861 0.17273 5.31329 0.399772C4.24804 0.626799 3.27055 1.18697 2.50402 2.00826C1.73755 2.82947 1.21627 3.87496 1.00515 5.01218C0.794022 6.14939 0.902328 7.3282 1.31661 8.39981C1.73091 9.47145 2.43291 10.3885 3.33488 11.0342ZM4.04961 2.39971C4.74144 1.90443 5.55402 1.64057 6.38462 1.64057C7.49826 1.64057 8.5678 2.11449 9.35752 2.96062C10.1474 3.80697 10.5923 4.95626 10.5923 6.15596C10.5923 7.05049 10.3447 7.92443 9.88149 8.66721C9.4183 9.40994 8.76066 9.98773 7.99254 10.3286C7.22453 10.6695 6.37988 10.7585 5.56508 10.5849C4.75021 10.4112 4.00069 9.98233 3.41173 9.3513C2.8227 8.7202 2.42087 7.91532 2.25802 7.03812C2.09516 6.16091 2.1788 5.25172 2.4981 4.42578C2.81739 3.59988 3.35768 2.89507 4.04961 2.39971Z" fill="white" stroke="#512DA8" stroke-width="0.2" />
                                        <path d="M14.4588 15.4864C14.5436 15.4869 14.6274 15.4694 14.7054 15.4352C14.7836 15.401 14.8543 15.3507 14.9136 15.2877C14.973 15.2245 15.0198 15.1497 15.0517 15.0677C15.0835 14.9858 15.0999 14.8981 15.0999 14.8097C15.0999 14.7213 15.0835 14.6337 15.0517 14.5517C15.0199 14.4698 14.9731 14.3951 14.9137 14.3319C14.9137 14.3319 14.9136 14.3318 14.9136 14.3318L10.6104 9.71858C10.5513 9.65523 10.4808 9.60457 10.4026 9.56987C10.3245 9.53516 10.2404 9.51719 10.1554 9.51719C10.0703 9.51719 9.98625 9.53516 9.90808 9.56987C9.82994 9.60457 9.7594 9.65523 9.70031 9.71858C9.64123 9.78191 9.5947 9.85673 9.56307 9.9386C9.53144 10.0205 9.51523 10.108 9.51523 10.1962C9.51523 10.2845 9.53144 10.372 9.56307 10.4539C9.5947 10.5357 9.64123 10.6106 9.70031 10.6739L14.0037 15.2874L14.004 15.2877C14.0633 15.3507 14.134 15.401 14.2122 15.4352C14.2902 15.4694 14.3741 15.4869 14.4588 15.4864ZM14.4588 15.4864C14.4586 15.4864 14.4584 15.4864 14.4582 15.4864L14.4588 15.3864L14.4594 15.4864C14.4592 15.4864 14.459 15.4864 14.4588 15.4864Z" fill="white" stroke="#512DA8" stroke-width="0.2" />
                                    </svg>
                                    Search
                                </button>
                            </form>
                        </div>
                        <div className={styles.subCatcheckCol}>
                            <div className={styles.displayFlex}>
                                <input type="checkbox" /> <span>Is Active</span>
                            </div>
                            <div className={styles.displayFlex}>
                                <input type="checkbox" /> <span>In stock</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.bomContentBox}>
                        <p>For multiple products upload sheet</p>
                        <h3>File Upload</h3>
                        <label htmlFor="doc">
                            <div className={styles.bomInnerBox} style={{ cursor: 'pointer' }}>
                                <Upload />
                                {
                                    filename ? <span>{filename}</span> :
                                        <span>Choose the file and sheet to upload</span>
                                }
                                <button className={styles.chooseBtn}>Choose File</button>
                                <input
                                    id='doc'
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileUpload}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </label>
                        <span>We support .xls, .xlsx and .csv files under 4MB</span>
                    </div>
                </div>

                <div className={styles.rightColumn}>
                    <div className={styles.toolListing}>
                        <span> Steps to follow:</span> <br />
                        <ul>
                            <li>
                                Enter a single part number to search, or upload your BOM spreadsheet for automatic matching.
                            </li>
                            <li>
                                Our matching wizard will scan available inventory and cross-reference equivalent components.
                            </li>
                            <li>
                                Review the matched alternatives, compare specifications, and select items to add to cart or request a quote.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {wizardProducts?.length > 0 &&
                <WizardTable
                    products={wizardProducts}
                    setProducts={setWizardProducts}
                    setShowLogin={setShowLogin}
                    isLoggedin={isLoggedin}
                    from={'wizard'}
                    submitLoading={submitLoading}
                />
            }
        </>
    )
}

export default WizardUpload
